import * as Vue from "vue";
import * as Vuex from "vuex";
import * as VueRouter from "vue-router";
import Axios from "axios";
import { Loader } from "@googlemaps/js-api-loader";

(<any>window).Vue = Vue;
(<any>window).Vuex = Vuex;
(<any>window).VueRouter = VueRouter;
(<any>window).Axios = Axios;
(<any>window).Loader = Loader;